'use client';

import { Locale } from '@peerless/ui-locale';
import { Authenticator, CurrentUserAttributes } from '@peerless/ui-amplify';
import { ModularSeriesConfigurator } from './ModularSeriesConfigurator';
import {
  AuthenticationInteropController,
  useAuthenticationInteropService,
} from './AuthenticationService';
import { Backdrop } from '@mui/material';

export interface ModularSeriesConfiguratorContainer {
  locale: Locale;
  user?: CurrentUserAttributes | undefined;
  configId?: string;
}

export function ModularSeriesConfiguratorContainer({
  locale,
  user,
  configId,
}: ModularSeriesConfiguratorContainer) {
  const [auth, onAuthenticated] = useAuthenticationInteropService(user);
  return (
    <>
      <ModularSeriesConfigurator
        auth={auth}
        language={locale.language}
        region={locale.region}
        configId={configId}
      />
      {!!onAuthenticated && (
        <Backdrop open style={{ zIndex: 5000, backdropFilter: 'blur(2px)' }}>
          <Authenticator>
            <AuthenticationInteropController callback={onAuthenticated} />
          </Authenticator>
        </Backdrop>
      )}
    </>
  );
}
